<template>
  <RevCard class="p-32">
    <div class="items-center lg:flex">
      <div class="mb-16 lg:mb-0 lg:mr-16">
        <h3 class="heading-3 mb-8">
          {{ i18n(translations.title) }}
        </h3>
        <p class="body-1">
          {{ i18n(translations.text) }}
        </p>
      </div>

      <RevButton
        class="mr-16"
        target="_blank"
        :to="API_DOC_LINK"
        variant="secondary"
      >
        {{ i18n(translations.documentation) }}
      </RevButton>
      <RevButton variant="primary" @click="handleCreate">
        {{ i18n(translations.create) }}
      </RevButton>
    </div>
  </RevCard>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevCard } from '@ds/components/Card'

import { getExternalLinkList } from '~/constants/externalLinks'

import translations from './Info.translations'

const emit = defineEmits(['create'])

const i18n = useI18n()
const { API_DOC_LINK } = getExternalLinkList(i18n.currentLocale)

function handleCreate() {
  emit('create')
}
</script>
